import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M16 13H13V3H11V13H8L12 17L16 13ZM3 19V21H21V19H3Z' />
  </>,
  'Download'
)
